import {createStore, withProps} from '@ngneat/elf';
import {withEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {TableConfig} from '@constants/table.constants';

import {Document, DocumentsFilters} from '@store/documents/documents.model';
import {TablePagination} from '@store/common/pagination.model';

export interface DocumentsState {
  filters: DocumentsFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const documentsStore = createStore(
  {name: 'documents'},
  withProps<DocumentsState>({
    filters: {search: '', tableFilters: DocumentsFilters.initTableFilters()},
    sort: {
      field: 'adminDocument.createdAt',
      sort: 'desc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<Document>(),
  withPagination(),
  withRequestsStatus(),
);
